import { createSlice } from '@reduxjs/toolkit';
import { Roleindicator, RoleindicatorState } from './roleindicatorTypes';
import { createRoleIndicator , fetchAllRoleindicator ,fetchRoleindicatorById , deleteRoleindicator ,updateRoleindicator } from './roleindicatorAction';

const initialState : RoleindicatorState = {
    roleindicator: [],
    selectedrole : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },

}

const roleindicatorSlice = createSlice({
    name : 'roleindicator',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
            .addCase(createRoleIndicator.pending, (state) => {
                                              state.loadingStates.create = true;
                                              state.errors.create = undefined;
                                          })
                                          .addCase(createRoleIndicator.fulfilled, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.roleindicator.push(action.payload);
                                          })
                                          .addCase(createRoleIndicator.rejected, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.errors.create = action.payload as string;
                                          })
                              
                                          // Update 
                                          .addCase(updateRoleindicator.pending, (state) => {
                                              state.loadingStates.update = true;
                                              state.errors.update = undefined;
                                          })
                                          .addCase(updateRoleindicator.fulfilled, (state, action) => {
                                              state.loadingStates.update = false;
                                              const index = state.roleindicator.findIndex((d : any) => d.Id === action.payload.Id);
                                              if (index !== -1) {
                                                  state.roleindicator[index] = action.payload;
                                              }
                                          })
                                          .addCase(updateRoleindicator .rejected, (state, action) => {
                                              state.loadingStates.update = false;
                                              state.errors.update = action.payload as string;
                                          })
                              
                                          // Delete 
                                          .addCase(deleteRoleindicator.pending, (state) => {
                                              state.loadingStates.delete = true;
                                              state.errors.delete = undefined;
                                          })
                                          .addCase(deleteRoleindicator.fulfilled, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.roleindicator = state.roleindicator.filter((d : any) => d.Id !== action.payload);
                                          })
                                          .addCase(deleteRoleindicator.rejected, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.errors.delete = action.payload as string;
                                          })
                              
                                          // Fetch  by ID
                                          .addCase(fetchRoleindicatorById.pending, (state) => {
                                              state.loadingStates.fetchById = true;
                                              state.errors.fetchById = undefined;
                                          })
                                          .addCase(fetchRoleindicatorById.fulfilled, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.selectedrole = action.payload;
                                          })
                                          .addCase(fetchRoleindicatorById.rejected, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.errors.fetchById = action.payload as string;
                                          })
                              
                                          // Fetch All 
                                          .addCase(fetchAllRoleindicator.pending, (state) => {
                                              state.loadingStates.fetchAll = true;
                                              state.errors.fetchAll = undefined;
                                          })
                                          .addCase(fetchAllRoleindicator.fulfilled, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.roleindicator = action.payload.data;
                                          })
                                          .addCase(fetchAllRoleindicator.rejected, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.errors.fetchAll = action.payload as string;
                                          }); 
    }
})

export default roleindicatorSlice.reducer;